// export default class langService {
export const langService = {
  langApp: 'fr',
  setLang(lang) {
    this.langApp = lang;
  },
  getLang() {
   return this.langApp;
  }
}